<template>
  <div v-for="(tallyAmount, tallyText) in tally" class="mb-3">
    <strong>{{ getTallyText(tallyText) }}:</strong> {{ tallyAmount }}
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import i18n from "@/entrypoints/shared/i18n_backend";

  const { t } = i18n.global;

  const props = defineProps({
    optionReference: {
      type: String,
      required: true,
    },
    writeInMapping: {
      type: Object,
      required: true,
    },
    uniqueWriteIns: {
      type: Object,
      required: true,
    },
    optionTitles: {
      type: Object,
      required: true,
    },
  });

  const tally = computed((): Record<string, number> => {
    const tally: Record<string, number> = {};
    const mappedValues = new Set<string>();

    // First pass: identify all values that have been mapped to (initial value changed)
    Object.entries(props.writeInMapping[props.optionReference]).forEach(([key, value]) => {
      if (key !== value) {
        mappedValues.add(value as string);
      }
    });

    // Second pass: count all instances for values that were mapped to
    Object.entries(props.writeInMapping[props.optionReference]).forEach(([key, value]) => {
      const valueStr = value as string;
      if (mappedValues.has(valueStr)) {
        tally[valueStr] = (tally[valueStr] || 0) + (props.uniqueWriteIns[key] || 0);
      }
    });

    return tally;
  });

  const getTallyText = (tallyText: string) => {
    if (tallyText.startsWith("$ref_")) {
      return `${props.optionTitles[tallyText.split("$ref_")[1]] ||
        t('backend.e2e.voting_round_reports.show.invalid')} (${tallyText.split("$ref_")[1]})`
    }
    if (tallyText.startsWith("$global_")) {
      return `${tallyText.split("$global_")[1]} (${t('backend.e2e.voting_round_reports.show.global')})`
    }
    return tallyText;
  };
</script>
